module.exports = __webpack_public_path__ + "assets/img/device.c2f970a2.png";